/**
 * Created by sy 2018.09.28
 * */
const STORAGE_KEY = 'menu-vuejs'

export default {
  fetch(){
    return window.JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]')
  },
  save(menu){
    window.localStorage.setItem(STORAGE_KEY, window.JSON.stringify(menu))
  }
}



// WEBPACK FOOTER //
// ./src/store.js